module.exports = __webpack_public_path__ + "static/logo-5ff93b3beaf46c7fb4d061096aab1660.svg";